import { formatInTimeZone } from "date-fns-tz";
import { getDeviceTZ } from "../intl/getDeviceTZ";

/**
 * Today on a given calendar, as `yyyy-MM-dd`, falling back to the viewer's own
 * when the zone is unknown.
 *
 * Whole-day spans that belong to a place - the days a desk is released, the
 * days an office is open - are that place's calendar days. Asked in the
 * viewer's zone instead, "today" is a day out whenever the two are on
 * different sides of midnight.
 */
export const todayInTimeZone = (timeZone: string | undefined): string =>
  formatInTimeZone(
    new Date(),
    timeZone || getDeviceTZ() || "UTC",
    "yyyy-MM-dd"
  );
